import RAPIER from '@dimforge/rapier3d-compat';

export const FIXED_TIMESTEP = 1 / 60;
const MAX_SUBSTEPS = 4;

/**
 * Rapier-Anbindung mit festem Zeitschritt und Akkumulator.
 * `alpha` erlaubt dem Renderer, zwischen zwei Physikschritten zu interpolieren,
 * damit die Darstellung auch bei 120-Hz-Displays glatt bleibt.
 */
export class PhysicsWorld {
  readonly world: RAPIER.World;
  private accumulator = 0;
  alpha = 0;

  private constructor(world: RAPIER.World) {
    this.world = world;
  }

  static async create(gravity = -9.81 * 1.6): Promise<PhysicsWorld> {
    await RAPIER.init();
    const world = new RAPIER.World({ x: 0, y: gravity, z: 0 });
    world.timestep = FIXED_TIMESTEP;
    world.numSolverIterations = 4;
    return new PhysicsWorld(world);
  }

  /**
   * Fuehrt so viele feste Schritte aus, wie in `dt` passen.
   * `beforeStep` wird vor jedem einzelnen Schritt aufgerufen (z. B. fuer den
   * Vehicle-Controller, der die Chassis-Geschwindigkeit direkt setzt).
   */
  step(dt: number, beforeStep: (fixedDt: number) => void): number {
    this.accumulator += Math.min(dt, 0.25);
    let steps = 0;
    while (this.accumulator >= FIXED_TIMESTEP && steps < MAX_SUBSTEPS) {
      beforeStep(FIXED_TIMESTEP);
      this.world.step();
      this.accumulator -= FIXED_TIMESTEP;
      steps += 1;
    }
    if (steps === MAX_SUBSTEPS) {
      // Wir kommen nicht hinterher: Restzeit verwerfen statt Spirale zu bauen.
      this.accumulator = 0;
    }
    this.alpha = this.accumulator / FIXED_TIMESTEP;
    return steps;
  }

  dispose(): void {
    this.world.free();
  }
}

export { RAPIER };
